module.exports = __webpack_public_path__ + "static/img/RAPS-U_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RAPS-U_1.png
// module id = 686R
// module chunks = 0